import { createRequest } from '@shared/services';

export async function getPromo() {
    const request = createRequest<GetPromoResponse>({
        url: '/promo/promo',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getPromoById(promoId: string) {
    const request = createRequest<GetPromoResponse>({
        url: `/promo/promo/${promoId}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function upsertPromo<T>(payload: T, promoId: string) {
    const isExistPromo = Boolean(promoId && promoId !== 'new');

    const url = isExistPromo ? `/promo/promo/${promoId}` : '/promo/promo';

    const method = isExistPromo ? 'PUT' : 'POST';

    const request = createRequest<PostPromoResponse>({
        url,
        method,
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}
